import { render, staticRenderFns } from "./NewDoctorModal.vue?vue&type=template&id=12cad4b3&scoped=true"
import script from "./NewDoctorModal.vue?vue&type=script&lang=js"
export * from "./NewDoctorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cad4b3",
  null
  
)

export default component.exports